module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.locked) ? _c('div', {
    class: {
      locked: true, readOnly: _vm.readOnly
    }
  }, [_vm._v("locked until: " + _vm._s(_vm.lockedUntil) + " / owner: " + _vm._s(_vm.lockedBy))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e8a49ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/components/lock-status.vue
// module id = 3325
// module chunks = 0